import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function HomeFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">常见问题</h2>
          <p className="mt-2 text-foreground-500 text-sm">关于鲍鱼域名访问的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left transition-colors hover:bg-background-100/50"
              >
                <span className="font-medium text-foreground-900 text-sm pr-4">{faq.question}</span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </div>
              </button>
              <div className={`transition-all duration-300 overflow-hidden ${openIdx === idx ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}